// Names of the learning languages, written in each interface language
const FLAGS = {
    italian: '🇮🇹', spanish: '🇪🇸', french: '🇫🇷', english: '🇬🇧', portuguese: '🇧🇷',
};

const NAMES = {
    en: { italian: 'Italian', spanish: 'Spanish', french: 'French', english: 'English', portuguese: 'Portuguese' },
    it: { italian: 'Italiano', spanish: 'Spagnolo', french: 'Francese', english: 'Inglese', portuguese: 'Portoghese' },
    es: { italian: 'Italiano', spanish: 'Español', french: 'Francés', english: 'Inglés', portuguese: 'Portugués' },
    fr: { italian: 'Italien', spanish: 'Espagnol', french: 'Français', english: 'Anglais', portuguese: 'Portugais' },
    pt: { italian: 'Italiano', spanish: 'Espanhol', french: 'Francês', english: 'Inglês', portuguese: 'Português' },
};

export function languageFlag(language) {
    return FLAGS[(language || '').toLowerCase()] || '';
}

export function languageLabel(language, interfaceLanguage) {
    const key = (language || '').toLowerCase();
    return (NAMES[interfaceLanguage] || NAMES.en)[key] || NAMES.en[key] || language;
}